export default "__VITE_ASSET__CugM7mnV__"